import { makeObservable, observable, reaction } from "dipole";

class ConstantsHelperStore {
    constructor() { 
        this.saveConstantsUri = observable.prop('')
        this.gatewayTileName = observable.prop('')
        this.constantsObj = observable.prop({})
        this.constantsJsonValuesUrl = observable.prop('')
        this.constantsUrl = observable.prop('')
        makeObservable(this);
    }

    getConstantsValues = (modelId, callBack, loaderId) => {
        var result;
        $.ajax({
            type: "GET",
            url: this.constantsJsonValuesUrl,
            async: true,
            contentType: "application/json",
            success: function (response) {
                result = response;
                var interval = setInterval(function () {
                    if (window.ackCioEvent) {
                        clearInterval(interval)
                        window.ackCioEvent.publish('onSucceedLoadWifiSettings', {})
                    }
                }, 10)
                callBack(result, modelId, loaderId);
            },
            error: function (req, status, err) {
                console.log(err);
                result = null;
                $("#" + loaderId).addClass("hidden");
                SnapeApp.Helpers.UIOperations.showMessage(Resources.GatewaySettingsJS.GetConstantsValuesApiFailed, false, "toast-bottom-left");
            }
        });
        return result;
    }

    showRelatedModel = (constantsObj, modelID, loaderID) => {
        if (constantsObj) {
            $("#" + modelID).modal({ show: true });
        }
        else {
            $("#" + loaderID).addClass("hidden");
            SnapeApp.Helpers.UIOperations.showMessage(Resources.GatewaySettingsJS.GetConstantsValuesApiFailed, false, "toast-bottom-left");
        }
    };


    onSuccessConstantValuesFromApi = (result, modelId, loaderId,) => {
        this.constantsObj = result;
        this.showRelatedModel(this.constantsObj, modelId, loaderId);
    };

    readConstantValuesFromApi = (modelId, loaderID) => {
        setTimeout(() => {
            this.getConstantsValues(modelId, this.onSuccessConstantValuesFromApi, loaderID);
        }, 0);
    };

    toggleSaveIndicators = (element, isShow) => {
        if (isShow)
            element.removeClass("hidden");
        else
            element.addClass("hidden");
    };
    

    saveConstansValues = (constJObject, tileName, successCallBack, errorCallBack) => {
        $.ajax({
            type: "POST",
            data: JSON.stringify(constJObject), // serialize dictionary object into string.
            url: this.constantsUrl + "?tileName=" + tileName,
            async: true,
            contentType: "application/json",
            success: (response) => {
                if (response.StatusCode === 200) {
                    successCallBack(response.ReasonPhrase);
                    window.shouldPromptChangingWifiConfig = false
                } else {
                    errorCallBack(response.ReasonPhrase);
                }
            },
            error: (req, status, err) => {
                errorCallBack();
            },
            complete: () => {
                if (tileName != this.gatewayTileName.internet) {
                    $("#exceptionsTable").DataTable().ajax.reload();
                }
            }
        });
    };

    hideModal =  (modal) => {
        SnapeApp.Helpers.UIOperations.hideModal(modal);
    };

    init = (store, constantUrl) => {
        reaction(() => {
            this.gatewayTileName = store.gatewayTileName
        }).run()
        this.constantsUrl = constantUrl

        reaction(() => {
            this.constantsJsonValuesUrl = store.constantsJsonValuesUrl
        }).run()
    }

}

export {
    ConstantsHelperStore
}
